<script lang="ts">
    export let size: number, color: string
</script>

<svg
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
>
    <rect
        style="stroke: {color}; stroke-width: 2px;"
        x="3"
        y="11"
        width="18"
        height="11"
        rx="2"
        ry="2"
    />
    <path style="stroke: {color}; stroke-width: 2px;" d="M7 11V7a5 5 0 0 1 9.9-1" />
</svg>
